import { useEffect, useState } from 'react';
import { getAccountName } from '@ibk/shared-utils';
export function useBpoDemo(companies) {
    const [admissions, setAdmissions] = useState([]);
    const [seeded, setSeeded] = useState(false);
    const [users, setUsers] = useState(() => ['Marcelo Andrade', 'Fernanda Lima', 'Ricardo Souza', 'Juliana Prado'].map((name, i) => ({
        id: `demo-user-${i}`,
        name,
        cpf: '000.000.000-00',
        email: `usuario${i + 1}@example.com`,
        phone: '(11) 90000-0000',
    })));
    const [clients, setClients] = useState(() => [
        'Padaria Estrela Ltda.',
        'Studio Alfa Design ME',
        'TechNova Sistemas S/A',
        'Transportes Rota Sul',
        'Clínica Vida Plena',
        'Mercado Bom Preço',
        'Oficina Motor Forte',
        'Escola Novo Saber',
    ].map((name, i) => ({
        id: `demo-client-${i}`,
        name,
        document: `${i + 1}0.111.222/0001-01`,
        city: 'São Paulo / SP',
        status: demoClientStatus(i),
    })));
    useEffect(() => {
        if (seeded || !companies.length)
            return;
        const statuses = ['waiting', 'received', 'analyzing', 'payroll', 'returned'];
        setAdmissions(statuses.map((status, i) => ({
            id: `demo-admission-${i}`,
            companyId: companies[i % companies.length].targetId,
            company: getAccountName(companies[i % companies.length]),
            name: ['Ana Exemplo', 'Bruno Exemplo', 'Carla Exemplo', 'Daniel Exemplo', 'Elisa Exemplo'][i],
            cpf: '000.000.000-00',
            email: `colaborador${i + 1}@example.com`,
            phone: '(11) 90000-0000',
            type: 'employee',
            payment: 'pix',
            observation: '',
            status,
            protocol: status === 'payroll' ? 'DEMO-FOLHA-0001' : undefined,
            reason: status === 'returned' ? 'Documento de demonstração incompleto.' : undefined,
            history: [{ date: new Date().toLocaleString(), text: 'Registro de demonstração.' }],
        })));
        setSeeded(true);
    }, [companies, seeded]);
    return { admissions, setAdmissions, users, setUsers, clients, setClients };
}
function demoClientStatus(index) {
    if (index === 2 || index === 7)
        return 'active';
    if (index === 1 || index === 5)
        return 'invited';
    return 'notInvited';
}
